<!-- ======= Blog Section ======= -->
<section id="blog" class="blog" style="padding-top: 170px;background-color: #f5f5f5;">
  <div class="container">

    <ngx-skeleton-loader count="5" appearance="line" *ngIf="blogs===undefined"></ngx-skeleton-loader>
    <!-- <ngx-shimmer-loading [shape]="'rect'" [width]="'100%'" [height]="'500px'" *ngIf="blogs===undefined">
    </ngx-shimmer-loading> -->

    <div class="row" *ngIf="blogs!==undefined">
      <div class="col-lg-12 entries" data-aos="fade-up" data-aos-delay="200">
        <article class="entry entry-single">

          <h2>Ask a Question about {{blogs.heading}}</h2>          
          <div class="row">
            <div class="col-md-6 mt-2">
              <input type="text" name="name" [(ngModel)]="name" class="form-control redborder" id="name"
                placeholder="Your Name" minlength="4" />
            </div>
            <div class="col-md-6 mt-2">
              <input type="text" name="company" [(ngModel)]="company" class="form-control redborder" id="company"
                placeholder="Your Company/Organization" minlength="10" />
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 mt-2">
              <input type="text" name="email" [(ngModel)]="email" class="form-control redborder" id="email"
                placeholder="Your Email Address" minlength="10" />
            </div>
            <div class="col-md-6 mt-2">
              <input type="text" name="phone" [(ngModel)]="phone" class="form-control redborder" id="phone"
                placeholder="Phone Number" minlength="7" />
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 mt-2">
              <textarea cols="5" rows="5" name="comments" [(ngModel)]="comments" class="form-control redborder" id="comments"
                placeholder="Happy to assist you with?" minlength="500"></textarea>
            </div>            
          </div>

          <div class="row">
            <div class="col-md-2">

            </div>
            <div class="col-md-5 mt-3">
                <button type="button" (click)="sendmessage()" class="btn btn-outline-primary btn-lg btn-block">Send Message</button>
            </div>
            <div class="col-md-3 mt-3">
              <button type="button" (click)="gotosafetypage()" class="btn btn-outline-secondary btn-lg btn-block">Back To Blog</button>
            </div>
            <div class="col-md-2">

            </div>
        </div>


        </article><!-- End blog entry -->

      </div><!-- End blog entries list -->
    </div>

  </div>
</section><!-- End Blog Section -->